import { Route, Routes } from 'react-router-dom'
import ApplicationRecordsListPage from './Page'

export default function AdmissionsIndex({ clientSchools, gradeLevel, types, academicYears }) {
  return (
    <Routes>
        <Route path="/" element={<ApplicationRecordsListPage clientSchools={clientSchools} gradeLevel={gradeLevel} types={types} academicYears={academicYears} />} />
        <Route path="/:applicationId/*" element={<ApplicationRecordsListPage clientSchools={clientSchools} gradeLevel={gradeLevel} types={types} academicYears={academicYears} />} />
    </Routes>
  )
}
